import * as React from 'react';
import { st, classes } from './IconButton.st.css';
import { CoreButtonNext as ButtonNext } from '../internal/WixUiCoreComponents/components/CoreButtonNext';
import { deprecationLog } from '../../common/deprecationLog';
import {
  IconButtonProps,
  IconButtonSkins,
  IconButtonDefaultProps,
  IconButtonThemes,
} from './types';

/** An implementation of an IconButton for TPAs,
 * The TPA implementation provides few extendable theme properties with the ability to override the base properties as well.
 * By default the IconButton will pull the theme from the site (site color scheme) */
export class IconButton extends React.Component<IconButtonProps> {
  static displayName = 'IconButton';
  static defaultProps: IconButtonDefaultProps = {
    theme: IconButtonThemes.None,
  };

  componentDidMount(): void {
    if (this.props.skin) {
      deprecationLog(
        'IconButton',
        'The prop "skin" is deprecated and will be removed in a future version, please use Toggle icons instead.',
      );
    }
  }

  render() {
    const {
      icon,
      disabled,
      skin = IconButtonSkins.Line,
      className,
      innerRef,
      theme,
      ...rest
    } = this.props;
    return (
      <ButtonNext
        className={st(
          classes.root,
          { disabled, skin, theme },
          classes[`skin-${skin}`],
          className,
        )}
        {...rest}
        disabled={disabled}
        ref={innerRef}
      >
        <span className={classes.icon}>{icon}</span>
      </ButtonNext>
    );
  }
}
